/**
 * @desc 根据系统单号和商品行编号获取订单包裹列表Item
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderPackageItemFacadeImpl.listBySpItemNoAndSono.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/systemOrderPackageItem/listBySpItemNoAndSono`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
